import { useState, useMemo, useEffect } from 'react';
import Fuse from 'fuse.js';
import { TickerInfo } from '../../providers/stock/types';

interface UseTickerSearchProps {
  tickers: TickerInfo[];
  searchTerm: string;
}

export const useTickerSearch = ({ tickers, searchTerm }: UseTickerSearchProps) => {
  const [searchResults, setSearchResults] = useState<TickerInfo[]>([]);

  const fuse = useMemo(() => {
    return new Fuse(tickers, {
      keys: [
        'isin',
        'ticker',
        'name',
        'exchange',
        'type',
        'short_name'
      ],
      threshold: 0.3,
      distance: 100,
      includeScore: true,
      minMatchCharLength: 2
    });
  }, [tickers]);

  useEffect(() => {
    if (!searchTerm) {
      setSearchResults([]);
      return;
    }

    const results = fuse.search(searchTerm);
    setSearchResults(results.map(result => result.item));
  }, [searchTerm, fuse]);

  return {
    searchResults,
    isLoading: false
  };
}; 